// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
interface Props {
  width?: number;
  height?: number;
  onClick?: VoidFunction;
}

export const IconManageGroup = ({
  width = 16,
  height = 16,
  onClick,
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      onClick={onClick}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 8.5C20.4805 8.5 22.5 10.4921 22.5 12.96C22.5 13.629 22.2033 14.4303 21.8232 15.2031C21.4343 15.9939 20.9213 16.8265 20.415 17.5791C19.9076 18.3335 19.4006 19.0172 19.0215 19.5117C18.8318 19.7592 18.6736 19.9604 18.5625 20.0996C18.507 20.1691 18.4627 20.2227 18.4326 20.2598C18.4176 20.2783 18.4064 20.293 18.3984 20.3027C18.3947 20.3073 18.3917 20.3109 18.3896 20.3135L18.3857 20.3174L18 20.7861L17.6143 20.3184V20.3174L17.6104 20.3135C17.6083 20.3109 17.6053 20.3073 17.6016 20.3027C17.5936 20.293 17.5824 20.2783 17.5674 20.2598C17.5373 20.2227 17.493 20.1691 17.4375 20.0996C17.3264 19.9604 17.1682 19.7592 16.9785 19.5117C16.5994 19.0172 16.0924 18.3335 15.585 17.5791C15.0787 16.8265 14.5657 15.9939 14.1768 15.2031C13.7967 14.4303 13.5 13.629 13.5 12.96C13.5 10.4921 15.5195 8.5 18 8.5Z"
        stroke="#6F6F6F"
      />
      <circle cx="18" cy="13" r="2" stroke="#6F6F6F" />
      <path
        d="M8 12.24C8 14.0294 5 18 5 18C5 18 2 14.0294 2 12.24C2 10.4506 3.34315 9 5 9C6.65685 9 8 10.4506 8 12.24Z"
        stroke="#6F6F6F"
      />
      <circle cx="5" cy="12" r="1" stroke="#6F6F6F" />
      <path
        d="M10.5 1.5C12.1604 1.5 13.4997 2.85561 13.5 4.51953C13.5 4.98755 13.299 5.52869 13.0596 6.02441C12.8116 6.53778 12.4856 7.0753 12.167 7.55762C11.8472 8.04162 11.5285 8.48023 11.29 8.79688C11.1708 8.95519 11.071 9.08351 11.001 9.17285C10.966 9.21743 10.938 9.25241 10.9189 9.27637C10.9094 9.28835 10.9016 9.29833 10.8965 9.30469C10.8941 9.30766 10.8919 9.30988 10.8906 9.31152L10.8896 9.31348L10.8887 9.31445L10.5 9.79492L10.1113 9.31445C10.1109 9.31398 10.11 9.31234 10.1094 9.31152C10.1081 9.30988 10.1059 9.30766 10.1035 9.30469C10.0984 9.29833 10.0906 9.28835 10.0811 9.27637C10.062 9.25241 10.034 9.21743 9.99902 9.17285C9.92896 9.08351 9.82917 8.95519 9.70996 8.79688C9.47154 8.48023 9.15278 8.04162 8.83301 7.55762C8.51436 7.0753 8.18839 6.53778 7.94043 6.02441C7.701 5.52869 7.5 4.98755 7.5 4.51953C7.50025 2.85561 8.83955 1.5 10.5 1.5Z"
        stroke="#6F6F6F"
      />
      <circle cx="10.5" cy="4.5" r="1" stroke="#6F6F6F" />
      <path
        d="M10.5 10.5C12 13 10.5 15.5 7 15"
        stroke="#6F6F6F"
        stroke-dasharray="1.5 1.5"
      />
      <path
        d="M5.5 18.5C6.5 20.1667 9.5 24 18 21"
        stroke="#6F6F6F"
        stroke-dasharray="1.5 1.5"
      />
      <circle cx="18" cy="21" r="1" fill="#6F6F6F" />
      <circle cx="5" cy="18" r="1" fill="#6F6F6F" />
      <circle cx="10.5" cy="10" r="1" fill="#6F6F6F" />
      <circle cx="10.5" cy="10.5" r="0.5" fill="#6F6F6F" />
    </svg>
  );
};
